export default __webpack_public_path__ + "static/icon-19-3-f36b2de1e2ecc4706ddc601351f7899c.png";